import { nl } from './nl'
import { en } from './en'

export type PortalLang = 'nl' | 'en'

export interface PortalTranslations {
  validate: {
    title: string
    subtitle: string
    cardNumber: string
    pin: string
    cardPlaceholder: string
    pinPlaceholder: string
    continue: string
    errors: {
      invalid: string
      inactive: string
      redeemed: string
      expired: string
      invalidCredentials: string
      cardUsed: string
      rateLimited: string
      addressRequired: string
      emailRequired: string
      unknown: string
    }
  }
  select: {
    title: string
    subtitle: string
    noGifts: string
    emailLabel: string
    emailPlaceholder: string
    emailInvalid: string
    emailBarLabel: string
    emailEmpty: string
    changeEmail: string
    chooseButton: string
    chosenButton: string
    selectButton: string
    changeEmailTitle: string
    changeEmailSubtitle: string
    cancel: string
    save: string
    addressTitle: string
    addressSubtitle: string
    addressEmptyNotice: string
    addressSave: string
    addressNameLabel: string
    addressStreetNameLabel: string
    addressHouseNumberLabel: string
    addressPostcodeLabel: string
    addressCityLabel: string
    addressCountryLabel: string
    addressFieldRequired: string
  }
  success: {
    title: string
    body: string
    errorTitle: string
    tryAgain: string
    footerPrivacy: string
    footerTerms: string
  }
  email: {
    subject: string
    codeLabel: string
    intro: string
    nameLabel: string
    poweredBy: string
  }
  langSwitch: string
}

const translations: Record<PortalLang, PortalTranslations> = { nl, en }

export function getTranslations(lang: PortalLang): PortalTranslations {
  return translations[lang] || translations.nl
}

/**
 * Parse a language string into a supported PortalLang.
 * File-based translations only exist for 'nl' and 'en'.
 * DB translations can support any language code.
 */
export function parseLang(value: string | undefined): PortalLang {
  if (value === 'en') return 'en'
  if (value === 'nl') return 'nl'
  return 'nl'
}

/**
 * Supported file-based languages (used as fallback).
 */
export const FILE_BASED_LANGS: PortalLang[] = ['nl', 'en']
